module.exports = __webpack_public_path__ + "static/img/play.e90c4a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/image/play.png
// module id = rgrn
// module chunks = 0